import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Fade,
  Chip,
  Alert,
  Divider,
  useTheme,
  alpha
} from "@mui/material";
import {
  Add as AddIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Work as WorkIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  Business as BusinessIcon,
  ContactPage as ContactIcon
} from "@mui/icons-material";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import styled from 'styled-components';
import { apiCall } from "../../../services/ApiCall";
import config from "../../../config/config.json";
import { useNavigate } from "react-router-dom";

// Styled Components

const HeaderWrapper = styled(Box)`
  margin-bottom: 24px;
  padding: 0 16px; 

`;
const StyledContainer = styled(Box)`

  min-height: 100vh;
  padding: 24px;
`;



const ContactCard = styled(Card)`
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(243, 243, 243, 1) !important;
  border: 1px solid rgba(13, 110, 253, 0.08);
  margin-bottom: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(243, 243, 243, 1) !important;
  }
`;

const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 12px !important;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease !important;
    
    &:hover {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 4px 12px rgba(243, 243, 243, 1);
    }
    
    &.Mui-focused {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0 0 2px rgba(243, 243, 243, 1);
    }
  }
  
  .MuiInputLabel-root {
    font-weight: 500;
    
    &.Mui-focused {
      color: #0d6efd;
    }
  }
`;

const StyledFormControl = styled(FormControl)`
  .MuiOutlinedInput-root {
    border-radius: 12px !important;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease !important;
    
    &:hover {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 4px 12px rgba(243, 243, 243, 1);
    }
    
    &.Mui-focused {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0 0 2px rgba(243, 243, 243, 1);
    }
  }
  
  .MuiInputLabel-root {
    font-weight: 500;
    
    &.Mui-focused {
      color: #0d6efd;
    }
  }
`;

const AddContactButton = styled(Button)`
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%) !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(243, 243, 243, 1) !important;
  }
`;

const ActionButton = styled(Button)`
  border-radius: 12px !important;
  padding: 12px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const StyledPhoneInput = styled.div`
  .react-tel-input {
    .form-control {
      border-radius: 12px !important;
      border: 1px solid rgba(0, 0, 0, 0.23) !important;
      background: rgba(255, 255, 255, 0.9) !important;
      height: 56px !important;
      font-size: 16px !important;
      transition: all 0.3s ease !important;
      
      &:hover {
        background: rgba(255, 255, 255, 1) !important;
        box-shadow: 0 4px 12px rgba(243, 243, 243, 1) !important;
      }
      
      &:focus {
        border-color: #0d6efd !important;
        box-shadow: 0 0 0 2px rgba(243, 243, 243, 1) !important;
        background: rgba(255, 255, 255, 1) !important;
      }
    }
  }
`;

const CompanyContact = ({ answer, setAnswer, onSwitchToDetail }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [contacts, setContacts] = useState([answer.userData]);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (index, key, value) => {
    const updatedContacts = contacts.map((contact, i) =>
      i === index ? { ...contact, [key]: value } : contact
    );
    setContacts(updatedContacts);
  };

  const addNewContact = () => {
    setContacts([...contacts, { fname: "", lname: "", email: "", phone: "", designation: "" }]);
  };

  const validate = () => {
    const newErrors = {};
    contacts.forEach((contact, index) => {
      const fname = contact.fname || "";
      const email = contact.email || "";
      const designation = contact.designation || "";

      if (!fname.trim()) {
        newErrors[`fname-${index}`] = "First Name is required";
      }
      if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
        newErrors[`email-${index}`] = "A valid Email is required";
      }
      if (!designation.trim()) {
        newErrors[`designation-${index}`] = "Designation is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const addNewCompanyAndContact = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSaving(true);
    const updatedAnswer = { ...answer, userData: contacts };
    const { isSuccess } = await apiCall(
      `${config.POST_LOGIN_API_URL}addNewCompanyAndContact`,
      {},
      updatedAnswer,
      "POST"
    );
    setSaving(false);
    if (isSuccess) {
      navigate("/company-list");
    }
  };

  const designationOptions = [
    "Owner",
    "District Manager", 
    "Compliance Manager",
    "General Manager"
  ];

  return (
    <StyledContainer>
      {/* Header Section */}
     <HeaderWrapper>
       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
         <IconButton 
           onClick={onSwitchToDetail}
           sx={{ mr: 1 }} 
         >
           <ArrowBackIcon />
         </IconButton>
         <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
           Add Company
         </Typography>
       </Box>
     
       <Box>
         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
           <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.primary' }}>
             Step 2 of 2
           </Typography>
           <Typography variant="body2" sx={{ color: 'text.secondary' }}>
             Contact Information
           </Typography>
         </Box>
         <Box sx={{ flexGrow: 1, height: '8px', background: alpha('#0d6efd', 0.2), borderRadius: '4px', overflow: 'hidden' }}>
           <Box sx={{ width: '100%', height: '100%', background: '#0d6efd', borderRadius: '4px' }} /> {/* 100% width for step 2 */}
         </Box>
       </Box>
     </HeaderWrapper>

      {/* Contact Forms */}
      <form onSubmit={addNewCompanyAndContact}>
        {contacts.map((contact, index) => (
          <Fade in timeout={500 + index * 200} key={index}>
            <ContactCard>
              <CardContent sx={{ p: 3 }}>
                {/* Contact Header */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ContactIcon sx={{ color: '#0d6efd', mr: 2, fontSize: 28 }} />
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a202c' }}>
                      Contact {index + 1}
                    </Typography>
                    {index === 0 && (
                      <Chip 
                        label="Primary"
                        size="small"
                        sx={{ 
                          ml: 2,
                          background: alpha('#4caf50', 0.1),
                          color: '#4caf50',
                          fontWeight: 600
                        }}
                      />
                    )}
                  </Box>
                  
                  <AddContactButton
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={addNewContact}
                  >
                    Add Contact
                  </AddContactButton>
                </Box>

                <Divider sx={{ mb: 3, borderColor: alpha('#0d6efd', 0.1) }} />

                {/* Form Fields */}
                <Grid container spacing={3}>
                  {/* Name Fields */}
                <Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      First Name <span style={{ color: 'red' }}>*</span>
    </Typography>
    <StyledTextField
      fullWidth
      placeholder="Enter First Name"
      value={contact.fname || ''}
      onChange={(e) => handleChange(index, "fname", e.target.value)}
      error={!!errors[`fname-${index}`]}
      helperText={errors[`fname-${index}`]}
      InputProps={{
        startAdornment: (
          <PersonIcon sx={{ color: '#64748b', mr: 1 }} />
        ),
      }}
      required
    />
  </Box>
</Grid>

                 <Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      Last Name
    </Typography>
    <StyledTextField
      fullWidth
      placeholder="Enter Last Name"
      value={contact.lname || ''}
      onChange={(e) => handleChange(index, "lname", e.target.value)}
      InputProps={{
        startAdornment: (
          <PersonIcon sx={{ color: '#64748b', mr: 1 }} />
        ),
      }}
    />
  </Box>
</Grid>

                  {/* Email Field */}
                 <Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      Email <span style={{ color: 'red' }}>*</span>
    </Typography>
    <StyledTextField
      fullWidth
      type="email"
      placeholder="Enter Email"
      value={contact.email || ''}
      onChange={(e) => handleChange(index, "email", e.target.value)}
      error={!!errors[`email-${index}`]}
      helperText={errors[`email-${index}`]}
      InputProps={{
        startAdornment: (
          <EmailIcon sx={{ color: '#64748b', mr: 1 }} />
        ),
      }}
      required
    />
  </Box>
</Grid>

                  {/* Phone Field */}
                  <Grid item xs={12} md={6}>
                    <Box>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          mb: 1, 
                          fontWeight: 500, 
                          color: '#64748b',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <PhoneIcon sx={{ mr: 1, fontSize: 20 }} />
                        Phone
                      </Typography>
                      <StyledPhoneInput>
                        <PhoneInput
                          country={'us'}
                          value={contact.phone || ''}
                          onChange={(phone) => handleChange(index, "phone", phone)}
                          inputStyle={{
                            width: '100%',
                            borderRadius: '12px'
                          }}
                          containerStyle={{
                            width: '100%'
                          }}
                        />
                      </StyledPhoneInput>
                    </Box>
                  </Grid>

                  {/* Designation Field */}
                 <Grid item xs={12} md={6}>
  <Box>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, ml: 1 }}>
      Designation <span style={{ color: 'red' }}>*</span>
    </Typography>
    <StyledFormControl fullWidth error={!!errors[`designation-${index}`]} required>
      <Select
        value={contact.designation || ''}
        onChange={(e) => handleChange(index, "designation", e.target.value)}
        displayEmpty
        renderValue={(value) => value || 'Select Designation'}
        startAdornment={
          <WorkIcon sx={{ color: '#64748b', mr: 1 }} />
        }
      >
        {designationOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
      {errors[`designation-${index}`] && (
        <Typography variant="caption" sx={{ color: 'error.main', mt: 0.5, ml: 2 }}>
          {errors[`designation-${index}`]}
        </Typography>
      )}
    </StyledFormControl>
  </Box>
</Grid>
                </Grid>

                {/* Error Alert */}
                {Object.keys(errors).some(key => key.includes(`-${index}`)) && (
                  <Alert severity="error" sx={{ mt: 2, borderRadius: '12px' }}>
                    Please correct the errors above before proceeding.
                  </Alert>
                )}
              </CardContent>
            </ContactCard>
          </Fade>
        ))}

        {/* Action Buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
          <ActionButton
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={onSwitchToDetail}
            disabled={saving}
            sx={{
              borderColor: '#64748b',
              color: '#64748b',
              '&:hover': {
                borderColor: '#0d6efd',
                color: '#0d6efd',
                background: alpha('#0d6efd', 0.05)
              }
            }}
          >
            Previous
          </ActionButton>

          <ActionButton
            type="submit"
            variant="contained"
            endIcon={<SaveIcon />}
            disabled={saving}
            sx={{
              background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #0a58ca 0%, #084298 100%)',
                boxShadow: '0 8px 25px rgba(13, 110, 253, 0.3)'
              }
            }}
          >
            {saving ? 'Saving...' : 'Save Company'}
          </ActionButton>
        </Box>
      </form>
    </StyledContainer>
  );
};

export default CompanyContact;